import {Box, CircularProgress} from "@mui/material";

interface AppLoaderProps {
}

export const AppLoader = ({}: AppLoaderProps) => {
    return (
        <Box
            height={`100dvh`}
            sx={{
                background: 'transparent',
                backgroundSize: '400% 400%',
                animation: 'gradientShift 10s ease infinite',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '@keyframes gradientShift': {
                    '0%': {
                        backgroundPosition: '0% 50%',
                    },
                    '50%': {
                        backgroundPosition: '100% 50%',
                    },
                    '100%': {
                        backgroundPosition: '0% 50%',
                    },
                },
            }}
        >
            <CircularProgress
                size={60}
                thickness={4}
                sx={{
                    color: 'rgba(255, 255, 255, 0.8)',
                }}
            />
        </Box>
    );
};
